var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { AppBar as Bar, Toolbar as _Toolbar, IconButton, Button, Typography, Box, Select as _Select, MenuItem, } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import { useMutation } from '@apollo/client';
import { context as ConfigContext } from '../context/config';
import { context as HistoryContext } from '../context/history';
import { commands } from '../../operations/commands';
import { currentUserVar, lastAccessedOrganizationVar, availableOrganizationsVar } from '../../cache';
import { flexibleLayoutContainer } from '../styleUtility/flexibleLayout';
import Spinner from './Spinner';
import UserMenu from './UserMenu';
import { SPACING_UNIT } from '../constant/spacing';
import theme from '../theme';
var AppBar = function (_a) {
    var className = _a.className;
    var config = useContext(ConfigContext);
    var history = useContext(HistoryContext);
    var currentOrganization = useReactiveVar(lastAccessedOrganizationVar);
    var currentUser = useReactiveVar(currentUserVar);
    var availableOrganizations = useReactiveVar(availableOrganizationsVar);
    var _b = useState(true), loadingOrganization = _b[0], setLoadingOrganization = _b[1];
    var _c = useMutation(commands.SIGNOUT), signout = _c[0], error = _c[1].error;
    useEffect(function () {
        if (!currentOrganization && availableOrganizations) {
            commands.setLastAccessedOrganization(availableOrganizations[0]);
        }
    }, [currentOrganization]);
    useEffect(function () {
        if (!availableOrganizations) {
            setLoadingOrganization(true);
        }
        setLoadingOrganization(false);
    }, [availableOrganizations]);
    var onClickExplore = useCallback(function () {
        history.push("/?org=" + (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id));
    }, [currentOrganization]);
    var onClickDatamarts = useCallback(function () {
        history.push("/destinations?org=" + (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id));
    }, [currentOrganization]);
    var onClickDatasources = useCallback(function () {
        history.push("/datasources?org=" + (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id));
    }, [currentOrganization]);
    var onChangeSelect = useCallback(function (selectedOrganizationId) {
        setLoadingOrganization(true);
        try {
            var selectedOrganization = availableOrganizations.find(function (organization) { return organization.id === selectedOrganizationId; });
            if (selectedOrganization) {
                history.push("/destinations?org=" + selectedOrganization.id);
                commands.setLastAccessedOrganization(selectedOrganization);
                return;
            }
        }
        catch (error) {
            throw new Error('selected organization not found');
        }
        finally {
            setLoadingOrganization(false);
        }
    }, [availableOrganizations]);
    var onClickSignOut = function () {
        signout();
        commands.disposeCurrentUser();
        commands.disposeLastAccessedOrganization();
    };
    var onClickAccountSettings = function () { return window.open("" + config.ID_WEB_URL, '_blank'); };
    return (React.createElement(Bar, { position: "static", className: className },
        React.createElement(Toolbar, { variant: "dense" },
            React.createElement(Menus, null,
                React.createElement(IconButton, { edge: "start", color: "inherit", "aria-label": "menu" },
                    React.createElement(MenuIcon, null)),
                React.createElement(Box, { mr: 2 },
                    React.createElement(TitleTypography, { variant: "h6" }, "Kaizen Data Platform")),
                React.createElement(Box, null,
                    React.createElement(Button, { color: "inherit", onClick: onClickExplore }, "Explore"),
                    React.createElement(Button, { color: "inherit", onClick: onClickDatamarts }, "Datamarts"),
                    React.createElement(Button, { color: "inherit", onClick: onClickDatasources }, "Data Sources"))),
            React.createElement(OrganizationSlecter, null,
                loadingOrganization ? (React.createElement(Spinner, { color: "inherit", size: 24 })) : availableOrganizations && currentOrganization && availableOrganizations.length > 0 ? (React.createElement(OrganizationSlecter, null,
                    React.createElement(Select, { value: currentOrganization.id, onChange: function (e) {
                            onChangeSelect(e.target.value);
                        } }, availableOrganizations.map(function (organization) { return (React.createElement(MenuItem, { value: organization.id, key: organization.id + "-" + organization.name },
                        React.createElement(Typography, null, organization.name))); })))) : null,
                React.createElement(Menu, { user: currentUser, onClickSignOut: onClickSignOut, onClickAccountSettings: onClickAccountSettings })))));
};
var TitleTypography = styled(Typography)({
    fontSize: '1.20rem',
});
var Toolbar = styled(_Toolbar)(__assign(__assign({}, flexibleLayoutContainer({
    justifyContent: 'space-between',
})), { height: 56, minHeight: 56 }));
var Menus = styled('div')(__assign({}, flexibleLayoutContainer({
    alignItems: 'center',
})));
var OrganizationSlecter = styled('div')(__assign({}, flexibleLayoutContainer({
    alignItems: 'center',
})));
var Select = styled(_Select)({
    backgroundColor: theme.palette.grey[100],
    borderRadius: 3,
    paddingLeft: SPACING_UNIT,
});
var Menu = styled(UserMenu)({
    marginLeft: 16,
});
export default AppBar;
